module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "goods-item",
    on: {
      "click": function($event) {
        return _vm.onNavigateTo()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.45rem",
      "height": "3.3rem"
    },
    attrs: {
      "src": _vm.row.pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-row"
  }, [_c('div', {
    staticClass: "goods-title show-one-row"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "flex-start goods-taps"
  }, _vm._l((_vm.row.discount_tags), function(item, index) {
    return (_vm.row.discount_tags.length > 0) ? _c('div', {
      staticClass: "goods-taps"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex-between goods-price-info"
  }, [_c('div', {
    staticClass: "flex-start goods-price-b"
  }, [_vm._v("\n\t\t\t\t\t¥"), _c('div', {
    staticClass: "goods-price"
  }, [_vm._v(_vm._s(_vm.row.price_range[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "goods-order-count"
  }, [_vm._v(_vm._s(_vm.row.views_count + _vm.row.sold_show_count) + "人付款")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efa0b6d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsItem.vue
// module id = 2629
// module chunks = 0